export default "__VITE_ASSET__Dwp$5x_y__"